// External
import React from 'react';

// App logo.
const Logo = () => {
    return (
        <svg
            width='150'
            height='150'
            viewBox='0 0 200 200'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M56.6987 25C83.4936 9.52995 116.506 9.52995 143.301 25V25C170.096 40.4701 186.603 69.0599 186.603 100V100C186.603 130.94 170.096 159.53 143.301 175V175C116.506 190.47 83.4936 190.47 56.6987 175V175C29.9038 159.53 13.3975 130.94 13.3975 100V100C13.3975 69.0599 29.9038 40.4701 56.6987 25V25Z'
                fill='#F26721'
            />
            <path
                d='M119.306 32.1923L125.948 109.658L151.306 135.78L55.3064 150.192L119.306 32.1923Z'
                fill='#FFFFFF'
            />
            <path
                d='M112.117 80.1474L136.794 58.5207L150.201 78.8819L112.117 80.1474Z'
                fill='#F26721'
            />
            <path
                d='M119.306 32.1922C119.306 36.1923 106.577 61.0731 89.1494 93.298C71.7222 125.523 58.3064 150.192 55.3064 150.192C51.5273 148.148 58.0369 118.122 75.4641 85.897C92.8913 53.6721 115.527 30.1485 119.306 32.1922Z'
                fill='#FFFFFF'
            />
        </svg>
    );
};

export default Logo;
